export const GET_REPLAY_CONFIG_LIST = 'GET_REPLAY_CONFIG_LIST';
export const SET_REPLAY_CONFIG_LIST = 'SET_REPLAY_CONFIG_LIST';
export const DELETE_REPLAY_CONFIG = 'DELETE_REPLAY_CONFIG';
export const SAVE_REPLAY_CONFIG = 'SAVE_REPLAY_CONFIG';
